// extracted by mini-css-extract-plugin
export default {"main":"index_main_p19eG clearfix","left":"index_left_1dmBf","right":"index_right_PmMDU"};